// AlertProvider.jsx
import React, { useState, useCallback } from 'react';
import Alert from './Alert';
import { AlertContext } from './AlertContext';

export const AlertProvider = ({ children }) => {
  const [alerts, setAlerts] = useState([]);

  const removeAllAlerts = useCallback(() => {
    setAlerts([]);
  }, []);

  const removeAlert = useCallback((id) => {
    setAlerts(prev => prev.filter(alert => alert.id !== id));
  }, []);

  const addAlert = useCallback((alertProps) => {
    const id = Math.random().toString(36).slice(2);
    setAlerts(prev => [...prev, { ...alertProps, id }]);
    return [id, () => removeAlert(id)];
  }, [removeAlert]);

  const showConfirm = useCallback((props) => {
    return new Promise((resolve) => {
      addAlert({
        type: 'confirm',
        duration: null,
        onConfirm: () => resolve(true),
        onCancel: () => resolve(false),
        ...props
      });
    });
  }, [addAlert]);

  return (
    <AlertContext.Provider value={{ 
      addAlert, 
      removeAlert, 
      removeAllAlerts, 
      showConfirm,
      alerts // esponiamo gli alerts correnti
    }}>
      {children}
      {/* Portal container per TUTTI gli alert */}
      <div className="fixed inset-0 isolate pointer-events-none" style={{ zIndex: 9999 }}>
        {/* Container per alert normali - responsive */}
        <div className="fixed top-4 w-full px-4 sm:px-0 sm:right-4 sm:w-auto flex flex-col items-center sm:items-end gap-3">
          {alerts
            .filter(alert => alert.type !== 'confirm')
            .map(alert => (
              <div key={alert.id} className="pointer-events-auto w-full sm:w-[420px]">
                <Alert
                  {...alert}
                  onClose={() => removeAlert(alert.id)}
                />
              </div>
            ))}
        </div>

        {/* Container per alert di conferma al centro */}
        {alerts.some(alert => alert.type === 'confirm') && (
          <>
            <div className="fixed inset-0 bg-light-scrim/50 dark:bg-dark-scrim/50 pointer-events-auto" />
            <div className="fixed inset-0 flex items-center justify-center p-4 pointer-events-auto">
              {alerts
                .filter(alert => alert.type === 'confirm')
                .map(alert => (
                  <Alert
                    key={alert.id}
                    {...alert}
                    onClose={() => removeAlert(alert.id)}
                    className="w-full max-w-[calc(100vw-2rem)] sm:max-w-md"
                  />
                ))}
            </div>
          </>
        )}
      </div>
    </AlertContext.Provider>
  );
};